let navigateFunction = null;

export const setNavigate = (navigate) => {
    navigateFunction = navigate;
};

export const navigate = (path) => {
    if (navigateFunction) {
        navigateFunction(path);
    } else {
        console.warn("navigate function not set, cannot navigate.");
    }
};
